// Ported from src/components/AudioRecorder/hooks/useSendRecording.js on 2026-10-05.
import type { AudioUploadResponse } from '../types/audioUpload.types';
import { useState } from 'react';
import apiClient from 'services/_infra/apiClient';
import { createAudioUploadFormData } from '../utils/audioFiles.utils';

export const useSendRecording = () => {
  const [uploadProgress, setUploadProgress] = useState<number | null | undefined>(null);

  const sendRecording = async (file: Blob, fileName: string, type: string, override = false) => {
    const formData = createAudioUploadFormData(file, fileName, type, override);

    setUploadProgress(0);

    try {
      const response = await apiClient.post<
        AudioUploadResponse['data'],
        AudioUploadResponse,
        FormData
      >('v2/integrations/device/audio', formData, {
        headers: { 'Content-Type': null },
        onUploadProgress: (event) => {
          setUploadProgress(event.progress);
        },
      });

      setUploadProgress(1);
      return response;
    } catch (error) {
      setUploadProgress(null);
      throw error;
    }
  };

  const clearProgress = () => setUploadProgress(null);

  return {
    uploadProgress,
    clearProgress,
    sendRecording,
  };
};
